// Sets sessionStorage flag to identify the deactivating tab
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  markDeactivatedTab() {
    sessionStorage.setItem('superuser_deactivated_here', 'true')
  }
}
